const ProfileCardHeader = ({ title }) => {
    return (
        <div className="card-header card-headercustom">
            <h2 className="h2 mb-0">{title}</h2>
        </div>
    )
}

export default ProfileCardHeader;